import { render, staticRenderFns } from "./TeamIndicatorsChart.vue?vue&type=template&id=2c15ee09"
import script from "./TeamIndicatorsChart.vue?vue&type=script&lang=js"
export * from "./TeamIndicatorsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports